<template>
  <div id="entityFee">
    <v-card>
      <v-card-text>
        <h2>Fee</h2>
        <template v-if="!editFeeFlag">
          <span v-if="entity.fee">{{ entity.fee.body | toCurrency }}</span>
          <span v-if="!entity.fee">Not set</span>
          &#160;
          <a @click="editFee">Change</a>
        </template>
        <div class="ajaxForm" v-if="editFeeFlag">
          <v-text-field type="number" label="Fee" v-model="feeCopy" />
          <v-btn @click="saveFee">Save</v-btn>
          <v-btn @click="editFeeFlag = false">Cancel</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import UPDATE_ENTITY_DETAIL_BY_TYPE from "@/graphql/directory/UpdateEntityDetailByType";
export default {
  name: "Fee",
  props: ["entity"],
  data() {
    return {
      feeCopy: null,
      editFeeFlag: false
    };
  },
  methods: {
    editFee() {
      if (this.entity.fee) {
        this.feeCopy = this.entity.fee.body;
      }
      this.editFeeFlag = true;
    },
    async saveFee() {
      await this.$apollo.mutate({
        mutation: UPDATE_ENTITY_DETAIL_BY_TYPE,
        variables: {
          id: Number(this.$route.params.id),
          typeid: 14,
          value: this.feeCopy
        }
      });
      // console.log(response.data);
      this.$emit("triggerUpdate");
      this.editFeeFlag = false;
    }
  }
};
</script>
